module.exports = __webpack_public_path__ + "static/media/boy-1.8547ceae.svg";